import React from 'react';
import Layout from '../../components/Layout';
import UtilisationDashboard from './UtilisationDashboard';

export default function UtilisationStatsPage() {
  return (
    <Layout appBarTitle="Utilisation Stats">
      <UtilisationDashboard />
    </Layout>
  );
}
